import { useEffect, useState } from "react";

const CITIES = [
  { code: "US", city: "New York", tz: "America/New_York" },
  { code: "UK", city: "London", tz: "Europe/London" },
  { code: "NL", city: "Amsterdam", tz: "Europe/Amsterdam" },
];

const fmt = (tz) => new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz }).format(new Date());

export const Clocks = () => {
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 30000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="grid grid-cols-3 divide-x divide-[rgba(212,175,55,0.18)]" data-testid="hero-market-clocks">
      {CITIES.map((c) => (
        <div key={c.code} className="px-3 first:pl-0 sm:px-6">
          <p className="font-mono-d text-[11px] uppercase tracking-[0.22em] text-[#D4AF37]">{c.code}</p>
          <p className="text-xs text-slate-400">{c.city}</p>
          <p className="font-serif-d mt-1 text-2xl text-white sm:text-3xl" data-testid={`clock-${c.code.toLowerCase()}`}>{fmt(c.tz)}</p>
        </div>
      ))}
    </div>
  );
};
